// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planoscontas_UpdateValorResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for update_valor endpoint
 *
 * Returns the updated item record with a message.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planoscontas_UpdateValorResponseDados {
id: number
plano_id: number
categoria_id: number
tipo: string
percentual_custom: number
valor_previsto: number
created_at: string
updated_at: string
message: string
}

export type Planoscontas_UpdateValorResponse = ApiResponse<Planoscontas_UpdateValorResponseDados>;

registerResponseContract('Planoscontas_UpdateValorResponse', {
  id:                { type: 'number',  required: true },
  plano_id:          { type: 'number',  required: true },
  categoria_id:      { type: 'number',  required: true },
  tipo:              { type: 'string',  required: true },
  percentual_custom: { type: 'number',  required: false },
  valor_previsto:    { type: 'number',  required: true },
  created_at:        { type: 'string',  required: true },
  updated_at:        { type: 'string',  required: true },
  message:           { type: 'string',  required: true },
})
